import { Link } from "react-router-dom";
import { CheckCircle2, ChevronRight, Circle } from "lucide-react";

export function SetupChecklist({ items }) {
  const doneCount = items.filter((i) => i.done && i.required).length;
  const requiredCount = items.filter((i) => i.required).length;
  return (
    <section className="mt-10" data-testid="dashboard-setup">
      <div className="flex items-baseline justify-between gap-3">
        <h3 className="text-lg font-semibold text-slate-900">Step 1 — Complete your setup</h3>
        <span className="text-xs text-slate-500" data-testid="dashboard-setup-progress">{doneCount} of {requiredCount} required done</span>
      </div>
      <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {items.map((i) => (
          <li key={i.key}>
            <Link
              to={i.to}
              className={`flex items-center gap-3 min-h-[56px] rounded-2xl border px-4 py-3 transition-colors ${i.done ? "border-emerald-200 bg-emerald-50/60 hover:bg-emerald-50" : "border-slate-200 bg-white hover:border-purple-300"}`}
              data-testid={`dashboard-setup-${i.key}`}
            >
              {i.done ? <CheckCircle2 size={20} className="text-emerald-600 shrink-0" /> : <Circle size={20} className="text-slate-300 shrink-0" />}
              <span className="flex-1 text-sm font-medium text-slate-800">{i.label}</span>
              <span
                className={`text-xs font-semibold rounded-full px-2.5 py-1 ${i.done ? "bg-emerald-100 text-emerald-800" : i.required ? "bg-amber-100 text-amber-900" : "bg-slate-100 text-slate-600"}`}
                data-testid={`dashboard-setup-${i.key}-status`}
              >
                {i.done ? "Complete" : "Missing"}
              </span>
              <ChevronRight size={16} className="text-slate-400 shrink-0" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
